import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { ACHIEVEMENTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/achievements/")({
  component: () => <DeptContentList cfg={ACHIEVEMENTS} />,
});
